import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';

import { stuut } from '@/api';

export function useBankAccounts() {
  const query = useQuery({
    queryKey: ['bank-accounts'],
    queryFn: () => stuut.bankAccounts.list(),
    staleTime: 5 * 60 * 1000,
  });

  return {
    bankAccounts: computed(() => query.data.value ?? []),
    isLoading: query.isLoading,
  };
}
